<div class="content-with-filled-button">
    <p class="sub-title offset-inline" id="generalTitle">
        {{copyService.copies.add_loan_subtitle}}
    </p>
    <br>
    <div class="content">
        <form [formGroup]="formData" autocomplete="off">
                <!-- formulario agregar prestamo -->
                <div formArrayName="addLoanForm">
                    <div *ngFor="let addForm of addLoanForm.controls; let i = index">
                        <h2 *ngIf="i != 0" class="sub-title offset-inline my-3" id="generalTitle">
                            {{copyService.copies.add_loan.subtitle}} #{{i+1}}
                        </h2>
                        <div class="row" [formGroup]="addForm">
                            <div class="col-pr-6">
                                <vcl-form-field [label]="copyService.copies.add_loan.valuePortfolio" [msgErr]="copyService.copies.add_loan.msgErr">
                                    <input vclInput formControlName="valuePortfolioForm" id="inputname" (keyup)="updateValueForm(i, 'valuePortfolioForm', $event)"
                                        [placeholder]="copyService.copies.add_loan.pValuePortfolio">
                                </vcl-form-field>
                            </div>
                            <div class="col-pr-6">
                                <voxel-form-field [label]="copyService.copies.add_loan.entityLoan"
                                    [msgErr]="copyService.copies.add_loan.msgErr">
                                    <vcl-autocomplete ngDefaultControl id="listbank"
                                        [placeholder]="copyService.copies.add_loan.pEntityLoan" formControlName="entityLoanForm">
                                        <vcl-option *ngFor="let list of bankList" [value]="list.name" (click)="selectOther(list, i)">
                                            {{ list.name }}
                                        </vcl-option>
                                    </vcl-autocomplete>
                                </voxel-form-field>
                            </div>

                            <div *ngIf="showNitName(i)" class="col-pr-6 my-2">
                                <vcl-form-field [label]="copyService.copies.add_loan.nameEntity" [msgErr]="copyService.copies.add_loan.msgErr">
                                    <input 
                                        vclInput
                                        formControlName="nameEntityForm"
                                        id="inputname"
                                        [placeholder]="copyService.copies.add_loan.nameEntity"
                                    >
                                </vcl-form-field>
                            </div>
                            <div *ngIf="showNitName(i)" class="col-pr-6 my-2">
                                <vcl-form-field 
                                    [label]="copyService.copies.add_loan.nitEntity"
                                    [msgErr]="copyService.copies.add_loan.msgErr"
                                    [description]="copyService.copies.add_loan.nit_description"
                                >
                                    <input 
                                        vclInput
                                        formControlName="nitEntityForm"
                                        id="inputname"
                                        [placeholder]="copyService.copies.add_loan.nitEntity"
                                        (keypress)="alphaNumberOnly($event)"
                                    > 
                                </vcl-form-field>
                            </div>

                            <div class="col-pr-6 my-2">
                                <vcl-form-field [label]="copyService.copies.add_loan.freeValue" [msgErr]="copyService.copies.add_loan.msgErr">
                                    <input vclInput formControlName="freeValueForm" id="inputname" (keyup)="updateValueForm(i, 'freeValueForm', $event)"
                                        [placeholder]="copyService.copies.add_loan.pFreeValue">  
                                </vcl-form-field>
                            </div>
                            <div class="col-pr-6 my-2">
                                <vcl-form-field [label]="copyService.copies.add_loan.numProduct" [msgErr]="copyService.copies.add_loan.msgErr">
                                    <input vclInput formControlName="numProductForm" appStringFormat id="inputname"
                                        [placeholder]="copyService.copies.add_loan.pNumProduct" option="alfa" minlength="3" maxlength="20">
                                </vcl-form-field>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- fin formulario agregar prestamo -->
                <vcl-button 
                    class="border"
                    *ngIf="showAdd"
                    [label]="copyService.copies.add_loan.addButton"
                    (click)="addLoan()"
                    buttonType="contextual"
                    [disableRipple]="true"
                    [disabled]="!formData.valid"
                >
                </vcl-button>
        </form>
    </div>
</div>
<app-controls 
    [hasPrevious]="true"
    [nextLabel]="copyService.copies.loan_agreements.button"
    [nextDisabled]="!formData.valid"
    (next)="next()"
    (only_previous)="back()">
</app-controls>